<template>
  <DashboardCard :loading="loading">
    <!-- <a
      class="extra-content"
      slot="headerExtraContent"
      @click.prevent.stop="topUpModalIsVisible = true"
    >
      {{ $t('dashboard.billing.top_up') }}
    </a> -->

    <div
      slot="body"
      class="adversting-budget"
    >
      <span class="adversting-budget__strong">
        {{ $t("adversting.available_on_balance") }}
      </span>
      <span>
        <span :class="[leftover < 0 ? 'adversting-budget__danger' : 'adversting-budget__positive']">
          {{ getPriceWithCurrency(leftover) }}
        </span>
        <a-popover>
          <a-icon
            type="info-circle"
            theme="twoTone"
          />
          <template #content>
            <div class="adversting-budget__popover">
              <div>
                <span style="font-weight: bold">
                  {{ $t("adversting.available_on_balance") }}
                </span>
                -
                {{ $t("adversting.available_on_balance_help") }}
              </div>
              <div style="display: flex; flex-flow: row nowrap; gap: 8px">
                <div style="font-weight: bold">
                  <div>{{ $t("adversting.shop_balance") }}:</div>
                  <div>{{ $t("adversting.amount_on_check_hold") }}:</div>
                </div>
                <div>
                  <div :class="{ 'adversting-budget__danger': balance < 0 }">
                    {{ getPriceWithCurrency(balance) }}
                  </div>
                  <div>
                    {{ getPriceWithCurrency(on_hold) }}
                  </div>
                </div>
              </div>
              <span style="opacity: 0.45">
                {{ $t("adversting.available_on_balance_equals") }}
              </span>
              <div v-if="leftover < 0">
                <span class="adversting-budget__danger">
                  {{ $t("tariffs.cpa_statistics.negativeBalanceAlert") }}
                </span>
              </div>
              <!-- Змінено логіку виводу сповіщення про від'ємний баланс у SNT-6363, якщо змін не буде, видалити закоментований блок знизу -->
              <!-- <div v-else-if="leftover < 0">
                <span class="adversting-budget__danger">{{
                  $t('tariffs.cpa_statistics.negativeBalanceWarning')
                }}</span>
              </div> -->
            </div>
          </template>
        </a-popover>
      </span>
      <!-- <BillingTopUp
        :visible="topUpModalIsVisible"
        @close="topUpModalIsVisible = false"
        @replenished="onBillingReplenished"
      /> -->
    </div>
  </DashboardCard>
</template>

<script>
import priceMixin from "@/mixins/price"

export default {
  name: "AdvertisingBudget",
  mixins: [priceMixin],
  props: {
    loading: {
      type: Boolean,
      default: false
    },
    balance: {
      type: Number,
      default: 0
    },
    leftover: {
      type: Number,
      default: 0
    },
    on_hold: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      topUpModalIsVisible: false
    }
  },
  methods: {
    onBillingReplenished() {
      this.topUpModalIsVisible = false

      this.$emit("update")
    }
  },
  components: {
    DashboardCard: () => import("@/components/Common/DashboardCard"),
    BillingTopUp: () => import("@/components/Common/BillingTopUp")
  }
}
</script>

<style lang="scss">
.extra-content {
  margin-left: auto;
}

.adversting-budget {
  display: flex;
  justify-content: space-between;

  &__strong {
    font-weight: 500;
    color: #262626;
  }

  &__on-check {
    color: #595959;
  }

  &__danger {
    color: #ff0000;
  }

  &__positive {
    color: #52c41a;
  }

  &__popover {
    max-width: 450px;
    display: flex;
    flex-flow: column nowrap;
  }
}
</style>
